<template>
  <v-container>
    <br />
    <br />
    <template>
      <v-row>
        <v-col cols="12" md="4" sm="4">
          <h4>Paketler</h4>
          <v-select
            v-model="subscriptionPlanPageData.subscriptionPlan"
            :items="allPlans"
            data-vv-name="select"
            item-text="name"
            item-value="value"
            @change="(plan) => filterPlanBySelectedPlan(plan)"
            required
          ></v-select>
        </v-col>
      </v-row>
    </template>
    <v-card>
      <v-card-title>
        Üyelikler
        <v-spacer></v-spacer>
      </v-card-title>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="allSubscriptionPlans"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100],
          disablePagination: true,
        }"
        :items-per-page="10"
        @update:page="getPageNumber"
        @update:items-per-page="getItemPerPage"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="routeSubscriptionPlanEdit(item)">
            mdi-pencil
          </v-icon>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          v-model="subscriptionPlanPageData.pageNumber"
          color="#4d48f9"
          :length="pagination.pagesLength"
          @input="setPageNumber"
        ></v-pagination>
      </div>
    </v-card>
  </v-container>
</template>
<script>
const SubscriptionType = {
  Basic: 'Basic',
  Plus: 'Plus',
}
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'SubscriptionPlans',
  data: () => ({
    search: '',
    subscriptionPlanPageData: {
      pageNumber: 1,
      pageSize: 10,
      subscriptionPlan: null,
    },
    pagination: {
      totalItems: 20,
      pagesLength: 10,
    },
    headers: [
      { text: 'Paket Adı', value: 'description', align: 'start' },
      { text: 'Fiyat', value: 'amount', sortable: false },
      { text: 'Paket Planı', value: 'name', sortable: false },
      { text: 'Detay', value: 'actions', sortable: false },
    ],
    allPlans: [
      {
        name: 'Hepsi',
        value: null,
      },
      {
        name: 'Plus Paketler',
        value: 'Plus',
      },
      {
        name: 'Basic Paketler',
        value: 'Basic',
      },
    ],
  }),
  computed: {
    ...mapGetters(['allSubscriptionPlans', 'loading']),
  },
  created() {
    const page = this.$route.query.page ? this.$route.query.page : 1
    this.subscriptionPlanPageData.pageNumber = Number(page)

    this.getSubscriptionPlans(this.subscriptionPlanPageData).then(
      (response) => {
        this.pagination.totalItems = response.totalCount
        this.pagination.pagesLength = response.totalPages
      },
    )
  },
  methods: {
    ...mapActions(['getSubscriptionPlans', 'updateSusbcriptionPlanAmount']),
    //Data table item per page changed function
    getItemPerPage(val) {
      this.subscriptionPlanPageData.pageSize = val
      this.subscriptionPlanPageData.pageNumber = 1
      this.getSubscriptionPlans(this.subscriptionPlanPageData).then(
        (response) => {
          this.pagination.pagesLength = response.totalPages
        },
      )
    },
    //Data table page number changed function
    getPageNumber(val) {
      this.subscriptionPlanPageData.pageNumber = val
      if (val !== 1) {
        this.$router.push({ query: { page: val } })
      }
      this.getSubscriptionPlans(this.subscriptionPlanPageData)
    },
    setPageNumber(val) {
      if (
        (!this.$route.query.page && val == 1) ||
        this.$route.query.page == val
      )
        return
      this.$router.push({ path: this.$route.fullPath, query: { page: val } })
    },
    //SubscriptionPlanEdit
    routeSubscriptionPlanEdit(item) {
      console.log('item', item)
      this.$router.push(`subscriptionPlan/${item.id}`)
    },
    filterPlanBySelectedPlan(plan) {
      this.getSubscriptionPlans(this.subscriptionPlanPageData).then(
        (response) => {
          this.pagination.totalItems = response.totalCount
          this.pagination.pagesLength = response.totalPages
        },
      )
    },
  },
  watch: {
    search: function (val, oldVal) {
      if (val.length < 2 && oldVal.length < 2) return
      this.getItemPerSearch(val)
    },
    '$route.query.page'(val) {
      const pageNumber = val ? Number(val) : 1
      this.getPageNumber(pageNumber)
    },
  },
}
</script>

<style>
.v-data-footer__icons-before {
  display: none;
}
.v-data-footer__icons-after {
  display: none;
}
</style>
